import { ReactComponent } from "./error-warning-fill.svg";

interface Props {
  width?: string;
  height?: string;
  fill?: string;
}

const ErrorWarningFillIcon: React.FC<Props> = (props) => (
  <ReactComponent {...props} />
);

export default ErrorWarningFillIcon;
